import PropTypes from "prop-types";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

import { useMaterialUIController } from "context";

function SidenavCollapse({ icon, name, active, ...rest }) {
  const [controller] = useMaterialUIController();
  const { miniSidenav } = controller;

  const content = (
    <ListItemButton
      {...rest}
      sx={{
        borderRadius: "18px",
        minHeight: 52,
        px: miniSidenav ? 1.5 : 1.75,
        mb: 0.75,
        justifyContent: miniSidenav ? "center" : "flex-start",
        background: active
          ? "linear-gradient(135deg, rgba(68,154,83,0.92) 0%, rgba(221,142,47,0.92) 100%)"
          : "transparent",
        color: active ? "#fff" : "rgba(243, 248, 240, 0.82)",
        border: active ? "1px solid rgba(255,255,255,0.12)" : "1px solid transparent",
        transition: "all 180ms ease",
        "&:hover": {
          backgroundColor: active ? "transparent" : "rgba(255,255,255,0.08)",
          color: "#fff",
        },
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: miniSidenav ? "unset" : 42,
          color: "inherit",
          justifyContent: "center",
        }}
      >
        {typeof icon === "string" ? <Icon>{icon}</Icon> : icon}
      </ListItemIcon>
      {!miniSidenav ? (
        <ListItemText
          primary={name}
          primaryTypographyProps={{
            fontSize: "0.92rem",
            fontWeight: active ? 700 : 600,
            letterSpacing: "0.01em",
          }}
        />
      ) : null}
    </ListItemButton>
  );

  if (miniSidenav) {
    return (
      <Tooltip title={name} placement="right">
        {content}
      </Tooltip>
    );
  }

  return content;
}

SidenavCollapse.defaultProps = {
  active: false,
};

SidenavCollapse.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

export default SidenavCollapse;
